/**
 * Türkçe karakterleri destekleyen büyük harf dönüşümü
 * JavaScript'in toUpperCase() fonksiyonu Türkçe karakterleri yanlış işler
 * Bu fonksiyon her karakteri manuel olarak kontrol eder
 */
export const toTurkishUpperCase = (text: string): string => {
  if (!text) return '';
  
  // Tüm karakter eşleştirmeleri (küçük -> büyük, büyük -> büyük)
  const charMap: { [key: string]: string } = {
    // Küçük harfler -> Büyük harfler
    'ı': 'I', 'i': 'İ', 'ğ': 'Ğ', 'ü': 'Ü', 'ş': 'Ş', 'ö': 'Ö', 'ç': 'Ç',
    'a': 'A', 'b': 'B', 'c': 'C', 'd': 'D', 'e': 'E', 'f': 'F',
    'g': 'G', 'h': 'H', 'j': 'J', 'k': 'K', 'l': 'L', 'm': 'M',
    'n': 'N', 'o': 'O', 'p': 'P', 'q': 'Q', 'r': 'R', 's': 'S',
    't': 'T', 'u': 'U', 'v': 'V', 'w': 'W', 'x': 'X', 'y': 'Y', 'z': 'Z',
    // Büyük harfler -> Büyük harfler (zaten büyükse olduğu gibi bırak)
    'I': 'I', 'İ': 'İ', 'Ğ': 'Ğ', 'Ü': 'Ü', 'Ş': 'Ş', 'Ö': 'Ö', 'Ç': 'Ç',
    'A': 'A', 'B': 'B', 'C': 'C', 'D': 'D', 'E': 'E', 'F': 'F',
    'G': 'G', 'H': 'H', 'J': 'J', 'K': 'K', 'L': 'L', 'M': 'M',
    'N': 'N', 'O': 'O', 'P': 'P', 'Q': 'Q', 'R': 'R', 'S': 'S',
    'T': 'T', 'U': 'U', 'V': 'V', 'W': 'W', 'X': 'X', 'Y': 'Y', 'Z': 'Z'
  };
  
  // Her karakteri tek tek kontrol edip doğru büyük harfe çevir
  return text
    .split('')
    .map(char => {
      // Eşleştirme tablosunda varsa, büyük harfini döndür
      if (charMap[char]) {
        return charMap[char];
      }
      
      // Diğer karakterler (rakam, noktalama, vb.) olduğu gibi bırak
      return char;
    })
    .join('');
};

/**
 * Türkçe karakterleri destekleyen alfabetik sıralama
 */
export const turkishSort = (a: string, b: string): number => {
  // Türkçe karakterlerin sıralama değerleri
  const turkishOrder: { [key: string]: number } = {
    'a': 1, 'b': 2, 'c': 3, 'ç': 4, 'd': 5, 'e': 6, 'f': 7, 'g': 8, 'ğ': 9,
    'h': 10, 'ı': 11, 'i': 12, 'j': 13, 'k': 14, 'l': 15, 'm': 16, 'n': 17,
    'o': 18, 'ö': 19, 'p': 20, 'q': 21, 'r': 22, 's': 23, 'ş': 24, 't': 25,
    'u': 26, 'ü': 27, 'v': 28, 'w': 29, 'x': 30, 'y': 31, 'z': 32
  };

  const normalize = (str: string): string => {
    return str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Diyakritik işaretleri kaldır
      .replace(/ı/g, 'ı')
      .replace(/i/g, 'i');
  };

  const aNorm = normalize(a);
  const bNorm = normalize(b);
  const minLen = Math.min(aNorm.length, bNorm.length);

  for (let i = 0; i < minLen; i++) {
    const aChar = aNorm[i];
    const bChar = bNorm[i];
    
    if (aChar === bChar) continue;
    
    const aOrder = turkishOrder[aChar] || aChar.charCodeAt(0) + 100;
    const bOrder = turkishOrder[bChar] || bChar.charCodeAt(0) + 100;
    
    if (aOrder < bOrder) return -1;
    if (aOrder > bOrder) return 1;
  }

  return aNorm.length - bNorm.length;
};

